<template lang="pug">
  section.information
    h1(:class="titleAnimation")  迈入数字经济时代，从现在开始
    h2 DATA ECONOMY ERA
    div
      div(v-for="(item, index) in information" :class="[contentAnimation, `animateDelay-${index}`]")
        .row
          .number {{ item.number }}
          .text {{ item.text }}
        .text {{ item.title }}
    button(@click="gotoExperience") 立即体验
</template>

<script>
  import Mixin from "../../index";
  export default {
    name: "information",
    mixins: [Mixin],
    data() {
      return {
        information: [
          {number: '100+', text: '项', title: '技术选项'},
          {number: '2', text: '小时', title: '极速云上'},
          {number: '20+', text: '项', title: '企业用户正在使用'},
        ],
      };
    },
    methods: {
      gotoExperience() {
        this.$router.push({name: 'GuestForm'});
        window.scrollTo(0, 0);
      },
    }
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .information {
    display flex
    flex-direction column
    align-items center
    height 608px
    width 100%
    padding-top 100px
    box-sizing border-box
    background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E7%A7%91%E6%8A%80%E7%BA%BF%E6%9D%A1.png") no-repeat center
    background-color #222222
  
    h1, h2, div, span {
      color white
    }
  
    h1 {
      &::after {
        background-color white
      }
    }
  
  
    > div {
      display flex
      align-items center
      justify-content center
      flex-wrap wrap
    
      > div {
        border 2px solid #666666
        background-color rgba(0, 0, 0, .15)
        display flex
        flex-direction column
        align-items center
        justify-content center
        height 148px
        width 290px
        margin 20px
      
        > .row {
          display flex
          align-items baseline
          justify-content center
        
          > .number {
            font-size 60px
            FontSetting(Montserrat)
            font-weight 400
          }
        
          > .text {
            font-size 18px
            FontSetting("思源黑体 CN Regular")
          }
        }
      
        > .text {
          font-size 14px
          FontSetting("思源黑体")
          font-weight 300
        }
      }
  
      
    }
  
    > button {
      height 38px
      width 126px
      color white
      background-color #269bff
      border-radius .5 * @height
      border 0
      outline none
      margin-top 70px
      FontSetting("思源黑体 CN Regular")
      box-sizing border-box
      padding 10px 0
      transition all .3s
      &:hover {
       transform scale(1.1)
      }
    }
    @media (max-width 990px) {
      height max-content
      padding-bottom 100px
      background-position bottom
    }
  }
  @media (max-width screenWidth) {
    .information {
      height max-content
      padding 50px 0
      background-position bottom
      > div {
        HStack()
        flex-wrap nowrap
        width 100%
        overflow-x auto
        > div {
          height 150px
          width 60%
          flex-shrink 0
          > .row {
            > .number {
              font-size 24px
            }
          }
        }
      }
      > button {
        margin-top 30px
      }
    }
  }
</style>
